/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable import/extensions */
/* eslint-disable import/no-named-default */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import { FormControlLabel } from "@material-ui/core";
import { default as MuiCheckbox } from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

import { theme } from "../theme/theme";

const StyledFormControlLabel = withStyles(() => {
  return {
    label: {
      color: `${theme.color.gray800}`,
      fontFamily: `${theme.fontFamily}`,
      fontSize: `${theme.fontSize.m}`,
    },
    root: {
      height: "26px",
      margin: "0px",
    },
  };
})(FormControlLabel);

type CheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  handleChange: (event) => void;
  id: string;
  indeterminate?: boolean;
  label?: string;
};

const StyledCheckbox = withStyles(() => {
  return {
    root: {
      color: `${theme.color.gray300}`,
      "& .MuiSvgIcon-root": {
        height: "20px",
        width: "18px",
      },
      "&$checked": {
        color: `${theme.color.gray800}`,
      },
      "&:hover": {
        backgroundColor: `${theme.color.gray200}`,
        borderRadius: "4px",
        color: `${theme.color.gray800}`,
      },
      padding: "5px",
    },
    checked: {},
  };
})(MuiCheckbox);

const Checkbox = ({
  checked,
  disabled,
  handleChange,
  id,
  indeterminate,
  label,
}: CheckboxProps): React.ReactElement => {
  return (
    <StyledFormControlLabel
      control={
        <StyledCheckbox
          checked={checked}
          data-checked={checked}
          data-testid={id}
          disabled={disabled}
          id={id}
          indeterminate={indeterminate}
          onChange={handleChange}
        />
      }
      label={label}
    />
  );
};

Checkbox.defaultProps = {
  indeterminate: false,
  label: "",
};

export default Checkbox;
